module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<select data-field-code=\"<%= model.fieldCode %>\">\n<%\nfor(var og in model.options || []){\noptGroup = model.options[og];\n%><optgroup label=\"<%= optGroup.title || '' %>\"><%\nfor(var o in optGroup.options || {}){\n%><option value=\"<%= o %>\"><%= optGroup.options[o] %></option><%\n}\n%></optgroup><%\n}\n%>\n</select>"
  , __filename = "components/templates/newsletter/form/fields/newsletterTemplateSelect.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<select data-field-code=\"")
    ; __append(escapeFn( model.fieldCode ))
    ; __append("\">\n")
    ; __line = 2
    ; 
for(var og in model.options || []){
optGroup = model.options[og];

    ; __line = 5
    ; __append("<optgroup label=\"")
    ; __append(escapeFn( optGroup.title || '' ))
    ; __append("\">")
    ; 
for(var o in optGroup.options || {}){

    ; __line = 7
    ; __append("<option value=\"")
    ; __append(escapeFn( o ))
    ; __append("\">")
    ; __append(escapeFn( optGroup.options[o] ))
    ; __append("</option>")
    ; 
}

    ; __line = 9
    ; __append("</optgroup>")
    ; 
}

    ; __line = 11
    ; __append("\n</select>")
    ; __line = 12
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/newsletter/form/fields/newsletterTemplateSelect.ejs

}